import React, { Component } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import SubmitButton from "../../UtilFormInputs/SubmitButton/SubmitButton.component";
import { enhancedInput } from "../../../../../../components/utils/InputHOC/InputHOC";
import BaseInputComponent from "../../../../../../components/utils/InputHOC/BaseInputComponent.component";
import { baseInputStrings } from "../../../../../../components/utils/InputHOC/BaseInput.strings";
import SubmitButtonExistAccount from "../../UtilFormInputs/SubmitButton/SubmitButtonExistAccount.component";

export interface RecoverFormProps {
    onSubmit?: (credentials) => any;
    onChangePage: any;
}

const initialValues = {
    email: ""
};

const validationSchema = Yup.object().shape({
    email: Yup.string().required("e-mail is required")
});

export default class LoginForm extends Component<RecoverFormProps, {}> {
    handleKeyPress = (e, formikProps) => {
        if (e.keyCode === 13 && e.shiftKey === false) {
            if (formikProps.isValid) {
                this.props.onSubmit(formikProps.values);
            }
        }
    };

    render() {
        const emailInput = enhancedInput({
            WrappedComponent: BaseInputComponent,
            id: "Email",
            placeholder: baseInputStrings.EMAIL,
            inputType: "email"
        });

        return (
            <div className="auth-form">
                <Formik
                    initialValues={initialValues}
                    onSubmit={values => this.props.onSubmit(values)}
                    validationSchema={validationSchema}
                    render={props => {
                        return (
                            <div onKeyDown={e => this.handleKeyPress(e, props)}>
                                <Form>
                                    <Field
                                        className="auth-form-input"
                                        name="email"
                                        component={emailInput}
                                    />
                                    <div className="auth-form-btns">
                                        <Field component={SubmitButton} />
                                        <Field
                                            component={() => <SubmitButtonExistAccount
                                                onChangePage={this.props.onChangePage} />} />

                                    </div>
                                </Form>
                            </div>
                        );
                    }}
                />
            </div>
        );
    }
}
